import Dashboard from "../pages/Dashboard";
import ForgotPassword  from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import Signin  from "../pages/Signin";
import Track from "../pages/Track";
import CommandCenter from "../pages/CommandCenter";
import CreateUser from "../pages/CreateUser";
import {UserManagement} from "../pages/UserManagement";
import Report from "../pages/Dashboard/components/Reports"
import Performance from "../pages/Performance"

export const ROUTES = [{
    path: '/dashboard',
    protected: true,
    component: (<Dashboard />)
},
{
    path: '/track',
    protected: false,
    component: (<Track/>)
},
{
    path: '/user/create',
    protected: true,
    component: (<CreateUser allowedRoles={['admin', 'logistics_manager']}/>)
},
{
    path: '/user/edit/:id',
    protected: true,
    component: (<CreateUser allowedRoles={['admin', 'logistics_manager']}/>)
},
{
    path: '/user-management',
    protected: true,
    component: (<UserManagement allowedRoles={['admin', 'logistics_manager']}/>)
},
{
    path: '/',
    protected: false,
    component: (<Signin />)
},
{
    path: '/forgotPassword',
    protected: false,
    component: (<ForgotPassword />)
},
{
    path: 'resetPassword/:token',
    protected: false,
    component: (<ResetPassword />)
},
{
    path: '/command-center',
    protected: true,
    component: (<CommandCenter />)
},
{
    path: '/reports',
    protected: true,
    component: (<Report />)
},
{
    path: '/performance',
    protected: true,
    component: (<Performance allowedRoles={['admin', 'logistics_manager']}/>)
}
]
